import request from '@/utils/request';

// 登录方法
export function login(data, loginType) {
  return request({
    url: '/login',
    method: 'post',
    data,
    params: { loginType }
  });
}
// 退出方法
export function logout() {
  return request({
    url: '/logout',
    method: 'post'
  });
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/captchaImage',
    method: 'get'
  });
}
